import { useEffect, useRef } from "react";
import useGetMongoUser from "hooks/User/useGetMongoUser/useGetMongoUser";
import useGetCompany from "hooks/useGetCompany";

export const PardotForm = ({ user }: { user: any }) => {
  const formRef = useRef<HTMLFormElement | null>(null);
  const { mongoUser } = useGetMongoUser();
  const { company } = useGetCompany();

  useEffect(() => {
    if (formRef.current && mongoUser?.jobTitle && company?.companyName) {
      formRef.current.submit();
    }
  }, [mongoUser?.jobTitle, company?.companyName]);

  return (
    <>
      <iframe
        name="hiddenFrame"
        style={{ display: "none" }}
        title="hiddenFormTarget"
      ></iframe>
      <form
        ref={formRef}
        action={process.env.REACT_APP_PARDOT_FORM_URL ?? ""}
        method="POST"
        target="hiddenFrame"
        data-testid="pardot-form"
      >
        <input type="hidden" name="firstname" value={user.firstName} />
        <input type="hidden" name="lastname" value={user.lastName} />
        <input type="hidden" name="email" value={user.email} />
        <input type="hidden" name="company" value={company.companyName} />
        <input type="hidden" name="jobtitle" value={mongoUser.jobTitle} />
      </form>
    </>
  );
};
